export interface Point {
  x: number;
  y: number;
}

export const distance = (a: Point, b: Point): number => Math.hypot(a.x - b.x, a.y - b.y);
export const clamp = (value: number, minimum: number, maximum: number): number =>
  Math.min(maximum, Math.max(minimum, value));
export const angleTo = (from: Point, to: Point): number => Math.atan2(to.y - from.y, to.x - from.x);
export const normalizeAngle = (radians: number): number =>
  Math.atan2(Math.sin(radians), Math.cos(radians));
export const pointInCircle = (point: Point, center: Point, radius: number): boolean =>
  distance(point, center) <= radius;
